import React from 'react';
import { Card, Box, Typography, Button, Stack, Paper } from '@mui/material';
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt';
import PhoneIcon from '@mui/icons-material/Phone';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import WaterIcon from '@mui/icons-material/Opacity';
import { api } from '../pages/suministros/api';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

const FacturaCard = ({ factura, onPay }) => {
  const getServiceIcon = (servTipo) => {
    switch(Number(servTipo)) {
      case 0:
        return (
          <Box display="flex" flexDirection="column" alignItems="center" gap={0.3}>
            <ElectricBoltIcon fontSize="medium" color = "success"  />
            <WaterIcon fontSize="medium" color="success" />
          </Box>
        );
      case 2:
      case 4:
      case 5:
      case 20:
      case 21:
      case 22:
        return <VolunteerActivismIcon fontSize="medium" color="success" />;
      case 3:
      case 6:
      case 23:
        return <PhoneIcon fontSize="medium" color="success" />;
      case 19:
        return <ReceiptLongIcon fontSize="medium" color="success" />;
      default:
        return <LightbulbIcon fontSize="medium" color="action" />;
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    const date = new Date(dateStr);
    if (isNaN(date.getTime()) || dateStr.startsWith('1753')) return '-';
    return date.toLocaleDateString();
  };
const handleDownloadPDF = async () => {
  try { 
    const blob = await api.pdf.getPDF(factura.pdf); 
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = factura.pdf + ".pdf"; 
    a.click();
    a.remove();
  } catch (err) {
    console.error("Error descarga PDF:", err);
  }
};

  const vencimientos = [
    { label: '1er Venc', date: factura.vto1, amount: factura.imp1 },
    { label: '2do Venc', date: factura.vto2, amount: factura.imp2 }
  ].filter(v => v.date && v.date !== "1753-01-01T00:00:00Z" && v.amount > 0);

  return (
    <Card
      sx={{
        mb: 2,
        p: 2,
        borderRadius: 3,
        boxShadow: 3,
        width: "100%",
        display: "flex",
        flexDirection: "row",
        alignItems: "stretch",
        '@media (max-width:600px)': { flexDirection: 'column', alignItems: 'flex-start' },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "grey.100",
          borderRadius: 2,
          p: 1,
          mr: 2,
          minWidth: 60,
          '@media (max-width:600px)': { mb: 1 },
        }}
      >
        {getServiceIcon(factura.servTipo)}
      </Box>

      <Box sx={{ flex: 1, pr: 1 }}>
        <Typography fontWeight="bold" sx={{ fontSize: '1rem', mb: 0.5 }}>
          {factura.compTpo}: {factura.compLet}-{factura.compNro}
        </Typography>

        <Box display="flex" alignItems="center" sx={{ mb: 0.5, gap: 2 }}>
          {/* <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontSize: '0.9rem' }}
          >
            {factura.servicio}
          </Typography> */}
          <Box display="flex" alignItems="center">
            <CalendarMonthIcon sx={{ fontSize: '1rem', mr: 0.5, color: 'text.secondary' }} />

            <Typography
              component="span"
              color="text.secondary"
              sx={{ fontSize: '0.8rem' }}
            >
              Periodo: {factura.Fac1MesCns?.toString().padStart(2, '0')}/{factura.Fac1AnoCns}
            </Typography>
          </Box>
        </Box>

        {vencimientos.length > 0 && (
          <Stack direction="row" spacing={1} mt={1}>
            {vencimientos.map((v, i) => (
              <Paper
                key={i}
                sx={{
                  p: 0.5,
                  borderRadius: 1.5,
                  bgcolor: "grey.50",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  gap: 0.3,
                  minWidth: 80,
                  justifyContent: 'center',
                }}
                elevation={1}
              >
                 <Typography variant="body2" color="text.secondary" fontWeight="bold" sx={{ fontSize: '0.8rem' }}>
                    {v.label}: {formatDate(v.date)}
                 </Typography>
                 <Typography variant="body2" color="error.main" fontWeight="bold" sx={{ fontSize: '1rem' }}>               
                    {v.amount.toLocaleString('es-AR', {
                      style: 'currency',
                      currency: 'ARS',
                    })}
                  </Typography>
              </Paper>
            ))}
          </Stack>
        )}
      </Box>

      <Stack spacing={1} justifyContent="center" sx={{ ml: 2, '@media (max-width:600px)': { mt: 1, ml: 0, flexDirection: 'row', gap: 1 } }}>
        {factura.pdf && (
        <Button
          size="small"
          variant="contained"
          color="primary"
          onClick={handleDownloadPDF}
          sx={{ fontSize: '0.75rem', minHeight: 30 }}
        >
          Descargar
        </Button>

        )}
        <Button
          size="small"
          variant="outlined"
          color="success"
          onClick={() => onPay(factura)}
          sx={{ fontSize: '0.75rem', minHeight: 30 }}
        >
          Pagar
        </Button>
      </Stack>
    </Card>
  );
};

export default FacturaCard;
